// extracted by mini-css-extract-plugin
export default {"container":"Header_container__pwj+d","heading":"Header_heading__lGxra","right":"Header_right__ogAWu","backgroundcolor":"Header_backgroundcolor__liGba"};